// ── FUNZIONI DI SUPPORTO — logica pura, nessun componente qui dentro ────────
import { TH, THOUGHT_FONTS, SEASONS, PRINT_PROVIDERS, BOOK_STYLES, BOOK_SIZES, BOOK_PAGE_RANGE, SWIPE_SCREENS } from './constants.js';
import { TODAY, DOY, YR } from './dateState.js';
// Bagliore ambientale in fondo allo schermo, dietro alle 6 sezioni
// principali — pensato apposta per la nuova barra vetrata (31/08/2026):
// senza questo, passando da una sezione all'altra la barra in vetro non
// aveva nessun colore da rifrangere sotto di sé (stesso sfondo piatto
// ovunque), quindi l'effetto vetro non si notava. SEMPRE colori del TEMA
// attivo (t.ac/t.ac2), mai colori fissi indipendenti dal tema — altrimenti
// una sezione "tradirebbe" il tema scelto dall'utente. Alternando quale dei
// due accenti del tema domina (pari→ac, dispari→ac2, seguendo l'ordine di
// SWIPE_SCREENS) le sezioni restano comunque abbastanza diverse tra loro da
// far vedere il passaggio sotto il vetro.
export function sectionGlowBg(name,t){
  const idx=SWIPE_SCREENS.indexOf(name);
  const dom=(idx>=0&&idx%2===1)?(t.ac2||t.ac):t.ac;
  return `radial-gradient(ellipse at 50% 100%,${dom}1c,transparent 62%),${t.bg}`;
}
export function isPhotoUrl(p){ return typeof p==="string" && (p.indexOf("http")===0 || p.indexOf("data:")===0); }
export function isThought(photo){ return typeof photo==="string"&&photo.startsWith("✏️"); }
export function thoughtFontKey(photo){ const k=isThought(photo)?photo.split(":")[1]:null; return THOUGHT_FONTS[k]?k:"inter"; }
export function thoughtFontStyle(photo){ const f=THOUGHT_FONTS[thoughtFontKey(photo)]; return {fontFamily:f.family,fontStyle:f.style,fontWeight:f.weight}; }
export function isInsideHScroll(el){
  let node=el;
  while(node&&node.nodeType===1&&node!==document.body){
    if(node.scrollWidth>node.clientWidth+4){
      const cs=window.getComputedStyle(node);
      if(cs.overflowX==="auto"||cs.overflowX==="scroll") return true;
    }
    node=node.parentElement;
  }
  return false;
}
export function resolveUserTheme(username){
  const keys=Object.keys(TH);
  let hash=0;
  for(let i=0;i<(username||"").length;i++) hash=(hash*31+username.charCodeAt(i))>>>0;
  return keys[hash%keys.length];
}
export function getSeasonForMonth(m){
  if(m<=2)return SEASONS[0];
  if(m<=5)return SEASONS[1];
  if(m<=8)return SEASONS[2];
  return SEASONS[3];
}
export function dayOfYearFromDate(d){ return Math.ceil((d-new Date(d.getFullYear(),0,1))/86400000); }
export function computeStreak(pages){
  if(!pages||pages.length===0)return 0;
  const daysSet=new Set(pages.map(p=>p.day));
  let streak=0, day=DOY;
  while(daysSet.has(day)){ streak++; day--; }
  return streak;
}
export function computeMetrics(st){
  const pages=(st.books[YR]&&st.books[YR].pages)||[];
  const todayPage=pages.find(p=>p.day===DOY);
  const month=TODAY.getMonth();
  const season=getSeasonForMonth(month);
  const quarterMonths=season.months;
  const pagesThisMonth=pages.filter(p=>{
    const d=new Date(YR,0,p.day);
    return d.getMonth()===month;
  }).length;
  const pagesQuarter=pages.filter(p=>{
    const d=new Date(YR,0,p.day);
    return quarterMonths.includes(d.getMonth());
  }).length;
  const filtersUsed=new Set(pages.map(p=>p.filter).filter(f=>f&&f!=="none")).size;
  const christmasPost=pages.some(p=>{ const d=new Date(YR,0,p.day); return d.getMonth()===11&&d.getDate()===25; })?1:0;
  const thanksgivingPost=pages.some(p=>{ const d=new Date(YR,0,p.day); return d.getMonth()===10&&d.getDate()>=22&&d.getDate()<=28; })?1:0;
  const easterWeekPost=pages.some(p=>{ const d=new Date(YR,0,p.day); return (d.getMonth()===2||d.getMonth()===3)&&d.getDate()>=1; })?1:0;
  const stickersUsed=pages.some(p=>p.sticker)?1:0;
  const filtersCreated=st.filters.filter(f=>f.mine).length;
  return{
    postedToday: todayPage?1:0,
    captionToday: (todayPage&&todayPage.caption)?1:0,
    reactionsGivenToday: (st.stats&&st.stats.reactionsGivenDate===DOY)?st.stats.reactionsGivenToday:0,
    filterUsedToday: (todayPage&&todayPage.filter&&todayPage.filter!=="none")?1:0,
    stickerUsedToday: (todayPage&&todayPage.sticker)?1:0,
    captionLongToday: (todayPage&&todayPage.caption&&todayPage.caption.length>=20)?1:0,
    captionAndStickerToday: (todayPage&&todayPage.caption&&todayPage.sticker)?1:0,
    earlyPostToday: (todayPage&&todayPage.ts&&new Date(todayPage.ts).getHours()<12)?1:0,
    streak: computeStreak(pages),
    pagesThisMonth, pagesQuarter,
    filtersUsed, filtersCreated, stickersUsed,
    microbooksCreated: st.micro.length,
    sharedBooksJoined: (st.sharedBooks||[]).length,
    christmasPost, thanksgivingPost, easterWeekPost,
  };
}
export function goalProgress(goal,metrics){
  const val=metrics[goal.metric]||0;
  return {value:Math.min(val,goal.target),target:goal.target,done:val>=goal.target};
}
// Sceglie "count" obiettivi dal pool in modo deterministico in base al seed
// (tipicamente anno*1000+giorno-dell'anno): stesso seed → stessa selezione,
// quindi resta stabile per tutta la giornata ma cambia il giorno dopo.
// Nessuna casualità vera in gioco — è un mescolamento riproducibile, non un
// Math.random() — così ricaricare l'app a metà giornata non fa sparire un
// obiettivo già iniziato.
// Livelli visivi del badge "fiamma" della serie giornaliera: colore della
// fiamma (esterno c1/c2 + nucleo interno cIn), animazione e durata crescono
// di intensità con i giorni di fila. Il numero è sempre nero e sempre
// visibile (anche a 0, per invogliare a far crescere la serie).
// 0 = fiamma spenta (grigia, statica). 1-10 attiva, 11-29 più vigorosa,
// 30-49 ancora di più, 50-69 fiamma azzurrina, 70-99 fiamma violacea.
export function flameTier(n){
  const c=n||0;
  const num="#000";
  if(c<1)  return {tier:0,c1:"#9b9b9b",c2:"#6c6c6c",cIn:"#4a4a4a",num,anim:"none",     dur:"0s"};
  if(c<=10)return {tier:1,c1:"#FFC15E",c2:"#FF5A36",cIn:"#FFE9B0",num,anim:"onceFlame1",dur:"2.0s"};
  if(c<=29)return {tier:2,c1:"#FFA531",c2:"#FF3D1F",cIn:"#FFD98A",num,anim:"onceFlame2",dur:"1.8s"};
  if(c<=49)return {tier:3,c1:"#FF8A1A",c2:"#FF1E1E",cIn:"#FFC670",num,anim:"onceFlame3",dur:"1.3s"};
  if(c<=69)return {tier:4,c1:"#8FE3FF",c2:"#1E90D8",cIn:"#E4F9FF",num,anim:"onceFlame4",dur:"1.0s"};
  return          {tier:5,c1:"#C89CFF",c2:"#7B2FFF",cIn:"#EAD9FF",num,anim:"onceFlame5",dur:".8s"};
}
// Quanto mostrare come numero della fiamma OGGI, dato lo stato salvato
// dailyStreak={count,lastDay,lastYear} e la data corrente (DOY/YR passati
// da chi chiama, per non dipendere da un import circolare su dateState).
// Prima si controllava solo lastDay===DOY (completato ESATTAMENTE oggi):
// il numero spariva (tornava a 0) ogni mattina finché non si rifacevano gli
// obiettivi del giorno, anche se la serie era ancora valida — un giorno
// completato ieri deve restare visibile per TUTTO il giorno di oggi, visto
// che è proprio oggi la finestra di tempo per allungarla senza perderla.
// Quindi resta valido se l'ultimo giorno segnato è oggi OPPURE ieri; da
// due giorni in poi la serie è davvero interrotta e si torna a 0.
export function streakDisplayCount(streak,doy,yr){
  if(!streak||!streak.count||streak.lastYear!==yr) return 0;
  if(streak.lastDay===doy||streak.lastDay===doy-1) return streak.count;
  return 0;
}
export function pickDailyGoals(pool,seed,count=3){
  const arr=[...pool];
  let s=(seed>>>0)||1;
  const rnd=()=>{ s=(s*1664525+1013904223)>>>0; return s/4294967296; };
  for(let i=arr.length-1;i>0;i--){
    const j=Math.floor(rnd()*(i+1));
    [arr[i],arr[j]]=[arr[j],arr[i]];
  }
  // Non prende più di un obiettivo dallo stesso "group" (es. le 3 varianti
  // "reagisci a N pagine" — sarebbero ridondanti nello stesso giorno).
  const picked=[], usedGroups=new Set();
  for(const g of arr){
    if(picked.length>=count) break;
    if(g.group){
      if(usedGroups.has(g.group)) continue;
      usedGroups.add(g.group);
    }
    picked.push(g);
  }
  return picked;
}
export function wrapCanvasText(ctx,text,x,y,maxWidth,lineHeight,maxLines){
  const words=(text||"").split(" ");
  let line="",lines=[];
  for(let i=0;i<words.length;i++){
    const test=line+words[i]+" ";
    if(ctx.measureText(test).width>maxWidth&&line!==""){ lines.push(line); line=words[i]+" "; }
    else line=test;
  }
  lines.push(line);
  lines=lines.slice(0,maxLines||3);
  lines.forEach((l,i)=>ctx.fillText(l.trim(),x,y+i*lineHeight));
}
// Cache in memoria (per la durata della sessione app) delle immagini già
// caricate con crossOrigin="anonymous" — necessario per poterle disegnare
// su canvas, ma questo flag fa sì che il browser NON riusi la copia della
// stessa foto già scaricata altrove nell'app (es. nel Feed, senza
// crossOrigin): senza questa cache, ogni apertura della condivisione
// esterna la riscarica da zero da rete, anche se è la stessa foto vista
// un attimo prima. Si tiene la Promise (non solo il risultato) così anche
// richieste in corso in parallelo per la stessa foto si condividono un
// solo download invece di farne due. In caso di errore, si rimuove dalla
// cache: un fallimento temporaneo di rete non deve bloccare per sempre i
// tentativi successivi.
const _imgElCache=new Map();
export function loadImgEl(src){
  if(_imgElCache.has(src)) return _imgElCache.get(src);
  const p=new Promise((resolve,reject)=>{
    const img=new Image();
    img.crossOrigin="anonymous";
    img.onload=()=>resolve(img);
    img.onerror=(e)=>{ _imgElCache.delete(src); reject(e); };
    img.src=src;
  });
  _imgElCache.set(src,p);
  return p;
}
export function drawCoverImg(ctx,img,x,y,w,h){
  const ir=img.width/img.height, tr=w/h;
  let sx,sy,sw,sh;
  if(ir>tr){ sh=img.height; sw=sh*tr; sx=(img.width-sw)/2; sy=0; }
  else{ sw=img.width; sh=sw/tr; sx=0; sy=(img.height-sh)/2; }
  ctx.drawImage(img,sx,sy,sw,sh,x,y,w,h);
}
export async function drawShareImage(canvas,item,filter,ut){
  // 1080×1350 (4:5) — il formato che Instagram stesso preferisce e mostra
  // per intero nel Feed da fine 2025 in poi. Consegnandolo già in questa
  // forma, non ha più bisogno di ritagliarlo lui stesso — niente più scelte
  // forzate tra vedere il logo o il nome, niente più dettagli persi ai lati.
  const W=1080, H=1350;
  canvas.width=W; canvas.height=H;
  const ctx=canvas.getContext("2d");
  const bg=ctx.createLinearGradient(0,0,W,H);
  bg.addColorStop(0,ut.ac); bg.addColorStop(1,ut.ac2||ut.ac);
  ctx.fillStyle=bg; ctx.fillRect(0,0,W,H);
  ctx.fillStyle="rgba(8,8,16,0.52)"; ctx.fillRect(0,0,W,H);
  ctx.save();
  if(filter&&filter.css&&filter.css!=="none"){ try{ ctx.filter=filter.css; }catch(e){} }
  if(isPhotoUrl(item.photo)){
    try{
      const img=await loadImgEl(item.photo);
      drawCoverImg(ctx,img,0,0,W,H);
    }catch(e){
      ctx.filter="none";
      ctx.font=`${W*0.4}px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif`;
      ctx.textAlign="center"; ctx.textBaseline="middle";
      ctx.fillText("📷",W/2,H*0.4);
    }
  }else if(isThought(item.photo)){
    ctx.filter="none";
    const fk=thoughtFontKey(item.photo);
    const cssFont=fk==="hand"?`italic 46px "Caveat",cursive`:fk==="mono"?`44px "Space Mono",monospace`:fk==="serif"?`italic 42px Georgia,serif`:`600 42px "Inter",sans-serif`;
    ctx.font=cssFont;
    ctx.fillStyle="#fff";
    ctx.textAlign="center"; ctx.textBaseline="middle";
    wrapCanvasText(ctx,item.cap||item.caption||"",W/2,H*0.42,W*0.74,W*0.07,6);
  }else{
    ctx.font=`${W*0.4}px "Apple Color Emoji","Segoe UI Emoji","Noto Color Emoji",sans-serif`;
    ctx.textAlign="center"; ctx.textBaseline="middle";
    ctx.fillText(item.photo||"📷",W/2,H*0.4);
  }
  ctx.restore();
  if(filter&&filter.tint){ ctx.fillStyle=filter.tint; ctx.fillRect(0,0,W,H); }
  if(filter&&filter.vig){
    const vg=ctx.createRadialGradient(W/2,H/2,W*0.28,W/2,H/2,W*0.9);
    vg.addColorStop(0,"rgba(0,0,0,0)"); vg.addColorStop(1,"rgba(0,0,0,.42)");
    ctx.fillStyle=vg; ctx.fillRect(0,0,W,H);
  }
  const gradH=H*0.26;
  const softGrad=ctx.createLinearGradient(0,H-gradH,0,H);
  softGrad.addColorStop(0,"rgba(0,0,0,0)");
  softGrad.addColorStop(1,"rgba(0,0,0,.64)");
  ctx.fillStyle=softGrad;
  ctx.fillRect(0,H-gradH,W,gradH);
  const cap=item.cap||item.caption;
  if(cap){
    ctx.font=`italic ${W*0.026}px Georgia,serif`;
    ctx.fillStyle="rgba(255,255,255,.95)";
    ctx.textAlign="center";
    wrapCanvasText(ctx,`"${cap}"`,W/2,H*0.85,W*0.76,W*0.038,2);
  }
  const bmH=W*0.05, bmW=bmH*0.68;
  const centerX=W/2;
  const bmY=H-W*0.075-bmH;
  const bmX=centerX-bmW-W*0.09;
  ctx.fillStyle="#FF2D6B";
  ctx.beginPath();
  ctx.moveTo(bmX,bmY); ctx.lineTo(bmX+bmW,bmY); ctx.lineTo(bmX+bmW,bmY+bmH);
  ctx.lineTo(bmX+bmW/2,bmY+bmH*0.72); ctx.lineTo(bmX,bmY+bmH); ctx.closePath();
  ctx.fill();
  ctx.strokeStyle="rgba(255,255,255,.75)"; ctx.lineWidth=bmH*0.06; ctx.lineCap="round";
  [0.32,0.52,0.7].forEach((f,i)=>{
    ctx.globalAlpha=1-i*0.25;
    ctx.beginPath();
    ctx.moveTo(bmX+bmW*0.22,bmY+bmH*f); ctx.lineTo(bmX+bmW*(0.8-i*0.1),bmY+bmH*f);
    ctx.stroke();
  });
  ctx.globalAlpha=1;
  ctx.textAlign="left"; ctx.textBaseline="middle";
  ctx.fillStyle="#fff"; ctx.font=`900 ${W*0.025}px Inter,sans-serif`;
  ctx.fillText("Oncer",bmX+bmW+W*0.018,bmY+bmH*0.32);
  ctx.fillStyle="rgba(255,255,255,.7)"; ctx.font=`${W*0.013}px Inter,sans-serif`;
  ctx.fillText("oncer.app",bmX+bmW+W*0.018,bmY+bmH*0.72);
  ctx.textAlign="center";
  ctx.fillStyle="rgba(255,255,255,.92)"; ctx.font=`700 ${W*0.019}px Inter,sans-serif`;
  ctx.fillText(`@${item.user||"tu"} · pagina ${item.day}`,centerX,bmY+bmH+W*0.032);
}
export const LS={
  g:(k,d)=>{try{const v=localStorage.getItem(k);return v!==null?JSON.parse(v):d;}catch(e){console.error("Oncer: lettura localStorage fallita per",k,"—",e.message);return d;}},
  s:(k,v)=>{try{localStorage.setItem(k,JSON.stringify(v));}catch(e){console.error("Oncer: SCRITTURA localStorage FALLITA per",k,"—",e.message,"(dati non salvati sul dispositivo!)");}},
};
export function recomputeToday(){
  TODAY=new Date();
  DOY=Math.ceil((TODAY-new Date(TODAY.getFullYear(),0,1))/86400000);
  YR=TODAY.getFullYear();
}
export function computeYearSummary(st){
  const pages=(st.books[YR]&&st.books[YR].pages)||[];
  const byMonth={};
  pages.forEach(p=>{ const mo=new Date(YR,0,p.day).getMonth(); byMonth[mo]=(byMonth[mo]||0)+1; });
  const topMonthIdx=Object.keys(byMonth).sort((a,b)=>byMonth[b]-byMonth[a])[0];
  const MONTH_NAMES=["Gennaio","Febbraio","Marzo","Aprile","Maggio","Giugno","Luglio","Agosto","Settembre","Ottobre","Novembre","Dicembre"];
  return {
    totalPages: pages.length,
    topMonth: topMonthIdx!==undefined?MONTH_NAMES[topMonthIdx]:null,
    topMonthCount: topMonthIdx!==undefined?byMonth[topMonthIdx]:0,
    longestStreak: computeStreak(pages),
    firstPage: pages.length?pages.reduce((a,b)=>a.day<b.day?a:b):null,
    filtersUsed: new Set(pages.map(p=>p.filter).filter(f=>f&&f!=="none")).size,
  };
}
export function pushToast(dispatch,message,kind="error"){
  dispatch({type:"SHOW_TOAST",message,kind});
}
export function compressImage(dataUrl,maxDim=1600,quality=0.82){
  return new Promise((resolve,reject)=>{
    const img=new Image();
    img.onload=()=>{
      let w=img.width,h=img.height;
      if(w>h&&w>maxDim){ h=Math.round(h*maxDim/w); w=maxDim; }
      else if(h>=w&&h>maxDim){ w=Math.round(w*maxDim/h); h=maxDim; }
      const canvas=document.createElement("canvas");
      canvas.width=w; canvas.height=h;
      canvas.getContext("2d").drawImage(img,0,0,w,h);
      canvas.toBlob(blob=>blob?resolve(blob):reject(new Error("compressione fallita")),"image/jpeg",quality);
    };
    img.onerror=()=>reject(new Error("immagine non valida"));
    img.src=dataUrl;
  });
}
export function blobToDataUrl(blob){
  return new Promise((resolve,reject)=>{
    const reader=new FileReader();
    reader.onload=()=>resolve(reader.result);
    reader.onerror=()=>reject(new Error("lettura immagine compressa fallita"));
    reader.readAsDataURL(blob);
  });
}
export function pickBestProvider(pageCount){
  const viable=PRINT_PROVIDERS.filter(p=>p.quality>=7);
  const scored=viable.map(p=>({...p,total:p.base+p.perPage*pageCount}));
  scored.sort((a,b)=>a.total-b.total);
  return scored[0]; // chosen silently — never rendered in the UI
}
export function calcPrintPrice(pageCount,format){
  const provider=pickBestProvider(pageCount); // internal cost basis only
  const margin=2.65;
  let raw=provider.total*margin;
  if(format==="pocket") raw*=0.72;
  const price=Math.ceil(raw)-0.10; // psychological .90 pricing
  return {price:Math.max(price,format==="pocket"?19.90:24.90),shipDays:provider.ship};
}
// ─────────────────────────────────────────────────────────────────────────
// Logica del nuovo wizard "scegli il tuo libro" (vedi PrintFormatView in
// Print.jsx) — sostituisce, per l'ordine reale, la stima finta sopra.
// Il prezzo VERO viene sempre chiesto dal vivo alla Edge Function
// get-print-quote (che interroga Gelato e/o Prodigi); queste funzioni
// servono solo a costruire la richiesta e a validare le scelte lato client
// prima di spedirla, così l'utente vede subito un errore chiaro invece di
// aspettare una risposta del server che sappiamo già sarebbe invalida.
//
// Data una scelta di stile ("softcover"|"hardcover"|"layflat"), restituisce
// i fornitori compatibili — un solo elemento per "layflat" (esclusiva
// Prodigi), entrambi per gli altri due.
export function vendorsForStyle(style){
  const s=BOOK_STYLES.find(x=>x.id===style);
  return s?s.vendors:["gelato","prodigi"];
}
// Taglie valide per uno stile, con i relativi orientamenti ammessi.
export function sizesForStyle(style){
  return BOOK_SIZES[style]||[];
}
// Adatta il numero di pagine al range supportato dallo stile scelto,
// arrotondando sempre a un numero pari (i libri si stampano a fogli doppi:
// una pagina dispari lascerebbe un retro bianco non richiesto). Ritorna sia
// il valore adattato sia se è stato necessario un adattamento, così la UI
// può mostrare l'avviso corrispondente (vedi print_wizard_pages_warning).
export function clampBookPageCount(pageCount,style){
  const range=BOOK_PAGE_RANGE[style]||{min:24,max:200};
  let n=Math.max(range.min,Math.min(range.max,pageCount));
  if(n%2!==0) n+=(n<range.max?1:-1);
  return {pageCount:n,adjusted:n!==pageCount,min:range.min,max:range.max};
}
// Costruisce lo SKU Prodigi per una combinazione stile/taglia/orientamento.
// Pattern verificato sui codici prodotto campione pubblicati da Prodigi
// (BOOK-FE-A4-P-HARD-G, BOOK-FE-A4-L-LF-G) — va confermato con una vera
// chiamata a GET /v4.0/products/{sku} prima di andare in produzione, per
// questo la Edge Function lo controlla sempre prima di usarlo in un ordine.
export function buildProdigiSku(style,sizeId,orientation){
  const sizeCode=sizeId==="a5"?"A5":sizeId==="a4"?"A4":sizeId==="square_l"?"SQL":sizeId==="square_s"?"SQS":sizeId==="square"?"SQ":"A4";
  const orCode=orientation==="landscape"?"L":orientation==="portrait"?"P":"S";
  const styleCode=style==="layflat"?"LF":style==="hardcover"?"HARD":"SOFT";
  return `BOOK-FE-${sizeCode}-${orCode}-${styleCode}-G`;
}
// Oggetto "scelta formato" completo che il client manda a get-print-quote
// e poi a create-print-checkout — un'unica forma condivisa dal wizard,
// dalla vista di riepilogo ordine e dal backend.
export function buildBookFormatSpec({style,sizeId,orientation,pageCount}){
  const sizeDef=(BOOK_SIZES[style]||[]).find(s=>s.id===sizeId);
  const {pageCount:clampedPages,adjusted,min,max}=clampBookPageCount(pageCount,style);
  return {
    style,sizeId,orientation,
    wIn:sizeDef?sizeDef.wIn:8.3,
    hIn:sizeDef?sizeDef.hIn:8.3,
    pageCount:clampedPages,pagesAdjusted:adjusted,pageMin:min,pageMax:max,
    vendors:vendorsForStyle(style),
    prodigiSku:buildProdigiSku(style,sizeId,orientation),
  };
}
export function shapeMsg(m,myId){
  return {from:m.sender_id===myId?"me":"them",txt:m.text,time:new Date(m.created_at).toLocaleTimeString("it-IT",{hour:"2-digit",minute:"2-digit"}),page:m.page_data||undefined};
}
export function seededRand(seed){
  let s=seed%2147483647; if(s<=0)s+=2147483646;
  return ()=>(s=(s*16807)%2147483647)/2147483647;
}
